"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_2 = require("react");
var react_hook_form_1 = require("react-hook-form");
var react_i18next_1 = require("react-i18next");
var OrderServiceContext_1 = require("../OrderServiceContext");
var FormConditionView = function () {
    var register = (0, react_hook_form_1.useFormContext)().register;
    var _a = (0, react_i18next_1.useTranslation)(), t = _a.t, i18n = _a.i18n;
    var _b = (0, OrderServiceContext_1.useOrderServiceContext)(), isConditionAccept = _b.isConditionAccept, setIsConditionAccept = _b.setIsConditionAccept;
    return (react_1.default.createElement(react_2.Fragment, null,
        react_1.default.createElement("input", __assign({ className: "custom-checkbox", type: "checkbox", defaultChecked: isConditionAccept }, register("is_condition"), { onChange: function (e) {
                setIsConditionAccept(e.target.checked);
            }, id: "color-1" })),
        react_1.default.createElement("label", { className: "__label-condition", htmlFor: "color-1" }, t("service.view.order.condition"))));
};
exports.default = FormConditionView;
